import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Per-page Open Graph + Twitter Card meta tags.
 * Falls back to sane defaults set in `public/index.html`.
 *
 * NOTE on production: WhatsApp + Facebook scrapers do not execute JavaScript,
 * so they will only see the default meta tags from index.html. React-helmet-async
 * is still useful for X/Twitter, LinkedIn, iMessage, Discord, Slack, and any
 * crawler that does run JS (Google does, too).
 */

const SITE_URL = 'https://myshaktiverse.com';
const DEFAULT_IMAGE =
  'https://customer-assets.emergentagent.com/job_ebb063e1-3e83-418f-bb38-602ef1351305/artifacts/yspj6tyg_Union%20of%20Shiva%20and%20Parvati.png';
const DEFAULT_TITLE = 'MyShaktiverse — The Game of Consciousness';
const DEFAULT_DESC =
  'A structured path drawn from the Himalayan Siddha tradition. Begin with Grahita Shakti.';

const absolutize = (url) => {
  if (!url) return DEFAULT_IMAGE;
  if (/^https?:\/\//i.test(url)) return url;
  const base = typeof window !== 'undefined' ? window.location.origin : SITE_URL;
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
};

const SEO = ({
  title,
  description,
  image,
  type = 'website',
  path,
  publishedAt,
  author,
}) => {
  const rawTitle = typeof title === 'string' && title.trim() ? title : DEFAULT_TITLE;
  const fullTitle = String(rawTitle);
  const desc = (typeof description === 'string' && description.trim())
    ? description
    : DEFAULT_DESC;
  const img = absolutize(image);
  const url = typeof window !== 'undefined'
    ? window.location.href
    : `${SITE_URL}${path || ''}`;

  return (
    <Helmet
      title={fullTitle}
      meta={[
        { name: 'description', content: desc },
        { property: 'og:site_name', content: 'MyShaktiverse' },
        { property: 'og:type', content: type },
        { property: 'og:url', content: url },
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: desc },
        { property: 'og:image', content: img },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: desc },
        { name: 'twitter:image', content: img },
        ...(type === 'article' && publishedAt
          ? [{ property: 'article:published_time', content: publishedAt }]
          : []),
        ...(type === 'article' && author
          ? [{ property: 'article:author', content: author }]
          : []),
      ]}
    />
  );
};

export default SEO;
